export default {
    validate:{
        len_10:'Maximum length is 10 characters',
        len_30:'Maximum length is 30 characters',
        len_50:'Maximum length is 50 characters.',
        len_20:'Maximum length is 20 characters.',
        len_120:'Maximum length is 120 characters.',
        len_255: 'Maximum length is 255 characters.',
        len_250: 'Length within 250',

        email_required: 'Email is required.',
        email_format:"Please enter a valid Email address.",

        customer_name_required: 'Company name is required',
        customer_code_required: 'Company ID is required.',
        customer_status_required: 'Company status is required.',
        customer_contact_required: 'Contact person is required.',
        customer_phone_required: 'Phone is required.',
        customer_email_required: 'Email is required.',
        customer_email_format: 'Please enter a valid Email address.',
        customer_phone_format: 'Please enter a valid phone number format.',

        //User
        user_name_required:"Name is required.",
        user_account_required:"Account is required.",
        user_role_required:"Role is required",
        user_mobile_required:"Mobile number is required.",
        user_company_required:"Company is required",
        user_role_type_required:"Role type is required",
        user_archit_required:"Associated organization is required",
        user_proxy_customer_required:"Agent customer is required",
        user_operable_resource_required:"Operable resources is required",

        //参数
        param_name_required:"Name is required.",
        param_code_required:"ID/SN is required.",
        param_content_required:"Parameter content is required.",

    }
}